export function isNil(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}

export function roundToDecimal(value: number, decimals: number) {
  return Math.round((value + Number.EPSILON) * 10 ** decimals) / 10 ** decimals;
}
